import type { LoginResponse } from '@/__generated__/openapi-types';
import type { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import type { TFunction } from 'i18next';

export type User = LoginResponse['user'];

type RouterContext = {
  isAuthenticated: boolean;
  persistLogin: (user: User, token: string, refreshToken: string) => void;
  queryClient: QueryClient;
  t: TFunction;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <Outlet />
      <TanStackRouterDevtools initialIsOpen={false} position="bottom-right" />
      <ReactQueryDevtools initialIsOpen={false} position="bottom" />
    </>
  ),
});
